export default "__VITE_ASSET__D9uDb1H2__"